import * as React from 'react'
import { SVGProps } from 'react'

const SvgTrashIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 20 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M19 4h-3.1A5.01 5.01 0 0 0 11 0H9a5.009 5.009 0 0 0-4.9 4H1a1 1 0 1 0 0 2h1v13a5.006 5.006 0 0 0 5 5h6a5.006 5.006 0 0 0 5-5V6h1a1 1 0 1 0 0-2ZM9 17a1 1 0 1 1-2 0v-6a1 1 0 1 1 2 0v6Zm4 0a1 1 0 1 1-2 0v-6a1 1 0 1 1 2 0v6ZM6.171 4A3.006 3.006 0 0 1 9 2h2a3.006 3.006 0 0 1 2.829 2H6.171Z'
      fill='#fff'
    />
  </svg>
)

export default SvgTrashIcon
